import Box from "glesys-controlpanel/components/box";
import Cost from "glesys-controlpanel/components/cost";
import IconsLoadingSpinner from "glesys-controlpanel/components/icons/loading-spinner";
import { t } from "ember-intl";

<template>
  <Box data-test-database-details-cost ...attributes>
    <span class="text-black text-sm">{{t "label.cost"}}</span>

    <div class="text-2xl 4xl:test-3xl text-black flex items-center gap-2 mt-2">
      {{#if @cost}}
        <Cost @currency={{@cost.currency}} @price={{@cost.current.price}} @discountedPrice={{@cost.current.total}} />
      {{else}}
        <IconsLoadingSpinner class="size-7" />
      {{/if}}
    </div>
  </Box>
</template>
